<script lang="ts">
    import Select from 'svelte-select';
    import Modal from './Bootstrap/Modal.svelte';
    import { parseStorage } from './Util/utils';
    import { ReccTrainingPills } from './Common/constants';
    // Filter display settings
    export let title = 'Filter';
    export let showSource = false;
    export let showLikedDisliked = false;
    export let showActivityFilters = true;
    export let hideFilterButton = false;
    export let forceFavOnly = false;
    export let defaultToBr = false;

    // export let doLoadFromSessionStorage = false;
    export let doLoadFromSessionStorage = false;

    let modalThis;
    // Modal control functions
    export const showModal = () => {
        form_searchBox = searchBox
        form_minDuration = minDuration
        form_maxDuration = maxDuration
        form_minXSS = minXSS
        form_maxXSS = maxXSS
        form_maxDiamonds = maxDiamonds
        form_minDiamonds = minDiamonds
        form_selectedFocus = selectedFocus
        form_selectedSpecificity = selectedSpecificity
        form_selectedPill = selectedPill

        form_showStandard = showStandard
        form_showCommunity = showCommunity
        form_showPersonal = showPersonal                  

        form_showLikedOnly = showLikedOnly
        form_showDislikedOnly = showDislikedOnly
        form_showFavouritesOnly = showFavouritesOnly
        form_showRecentsOnly = showRecentsOnly
        form_showBrOnly = showBrOnly
        modalThis.show();
    }
    export const closeModal = () => modalThis.close()

    export let onApply: Function;
    export let filterKey = 'workoutFilter';

    // Modal dropdown values
    let focus = [
        { label: 'All', value: 0, },
        { label: 'Power Sprinter', value: 1, },
        { label: 'Road Sprinter', value: 2, },
        { label: 'Pursuiter', value: 3, },
        { label: 'Puncheur', value: 4, },
        { label: 'Breakaway Specialist', value: 5, },
        { label: 'Rouleur', value: 6, },
        { label: 'GC Specialist', value: 7, },
        { label: 'Climber', value: 8, },
        { label: 'Endurance', value: 9, },
    ];

    let diamonds = [
        { label: '◆', value: 0, },
        { label: '◆⬖', value: 1, },
        { label: '◆◆', value: 2, },
        { label: '◆◆⬖', value: 3, },
        { label: '◆◆◆', value: 4, },
        { label: '◆◆◆⬖', value: 5, },
        { label: '◆◆◆◆', value: 6, },
        { label: '◆◆◆◆⬖', value: 7, },
        { label: '◆◆◆◆◆', value: 8, },
        { label: 'Unlimited', value: 9, },
    ];

    let specificity = [
        { label: 'All', value: 0, },
        { label: 'Pure', value: 1, },
        { label: 'Mixed', value: 2, },
        { label: 'Polar', value: 3, },
    ]

    // Modal field data
    let storage = parseStorage(filterKey);
    export let searchBox: string = storage.searchBox ?? '';
    export let minDuration: number = storage.minDuration;
    export let maxDuration: number = storage.maxDuration;
    export let minXSS: number = storage.minXSS;
    export let maxXSS: number = storage.maxXSS;
    export let minDiamonds = storage.minDiamonds ? diamonds[storage.minDiamonds] : undefined;
    export let maxDiamonds = storage.maxDiamonds ? diamonds[storage.maxDiamonds] : undefined;
    export let selectedFocus = storage.selectedFocus ? focus[storage.selectedFocus] : focus[0];
    export let selectedSpecificity = storage.selectedSpecificity ? specificity[storage.selectedSpecificity] : specificity[0];
    export let selectedPill = storage.selectedPill ? ReccTrainingPills[storage.selectedPill] : ReccTrainingPills[0];

    export let showStandard: boolean = storage.showStandard ?? true;
    export let showCommunity: boolean = storage.showCommunity ?? true;
    export let showPersonal: boolean = storage.showPersonal ?? true;

    export let showLikedOnly: boolean = storage.showLikedOnly ?? false;
    export let showDislikedOnly: boolean = storage.showDislikedOnly ?? false;
    export let showFavouritesOnly: boolean = storage.showFavouritesOnly ?? false;
    export let showRecentsOnly: boolean = storage.showRecentsOnly ?? true;
    export let showBrOnly: boolean  = storage.showBrOnly ?? defaultToBr

    let form_searchBox = searchBox
    let form_minDuration = minDuration
    let form_maxDuration = maxDuration
    let form_minXSS = minXSS
    let form_maxXSS = maxXSS
    let form_minDiamonds = minDiamonds
    let form_maxDiamonds = maxDiamonds
    let form_selectedFocus = selectedFocus
    let form_selectedSpecificity = selectedSpecificity
    let form_selectedPill = selectedPill

    let form_showStandard = showStandard
    let form_showCommunity = showCommunity
    let form_showPersonal = showPersonal                  

    let form_showLikedOnly = showLikedOnly
    let form_showDislikedOnly = showDislikedOnly
    let form_showFavouritesOnly = showFavouritesOnly
    let form_showRecentsOnly = showRecentsOnly
    let form_showBrOnly = showBrOnly

    export let hasFilter = false;

    export let durationManuallyChanged = true;
    let willManuallyChangeDuration = false;
    const onDurationInput = ()=>{
        willManuallyChangeDuration = true;
    }

    $: hasFilter = !!(searchBox || minDuration || maxDuration || minXSS || maxXSS || minDiamonds || maxDiamonds || selectedFocus.value != 0 || selectedSpecificity.value != 0 || selectedPill.value != 0 || !showStandard || !showCommunity || !showPersonal || showLikedOnly || showDislikedOnly || !showRecentsOnly || showFavouritesOnly)

    function loadFromSessionStorage() {
        storage = parseStorage(filterKey);

        searchBox = storage.searchBox ?? '';

        // TODO: Maybe save duration from dropdown?
        if (durationManuallyChanged) {
            minDuration = storage.minDuration;
            maxDuration = storage.maxDuration;
        }
        minXSS = storage.minXSS;
        maxXSS = storage.maxXSS;
        minDiamonds = storage.minDiamonds ? diamonds[storage.minDiamonds] : undefined;
        maxDiamonds = storage.maxDiamonds ? diamonds[storage.maxDiamonds] : undefined;
        selectedFocus = storage.selectedFocus ? focus[storage.selectedFocus] : focus[0];
        selectedSpecificity = storage.selectedSpecificity ? specificity[storage.selectedSpecificity] : specificity[0];
        selectedPill = storage.selectedPill ? ReccTrainingPills[storage.selectedPill] : ReccTrainingPills[0];

        showStandard = storage.showStandard ?? true;
        showCommunity = storage.showCommunity ?? true;
        showPersonal = storage.showPersonal ?? true;
        showLikedOnly = storage.showLikedOnly ?? false;
        showDislikedOnly = storage.showDislikedOnly ?? false;
        showFavouritesOnly = storage.showFavouritesOnly ?? false;
        showRecentsOnly = storage.showRecentsOnly ?? true;
        showBrOnly = storage.showBrOnly ?? showBrOnly;
    }

    function clearSessionStorage() {
        storage = {};
        sessionStorage.removeItem[filterKey];
    }

    function saveToSessionStorage() {
        clearSessionStorage();

        storage.searchBox = searchBox;
        if(minDuration) storage.minDuration = minDuration;
        if(maxDuration) storage.maxDuration = maxDuration;
        if(minXSS) storage.minXSS = minXSS;
        if(maxXSS) storage.maxXSS = maxXSS;
        storage.minDiamonds = minDiamonds ? minDiamonds.value : undefined;
        storage.maxDiamonds = maxDiamonds ? maxDiamonds.value : undefined;
        storage.selectedFocus = selectedFocus ? selectedFocus.value : undefined;
        storage.selectedSpecificity = selectedSpecificity ? selectedSpecificity.value : undefined;
        storage.selectedPill = selectedPill ? selectedPill.value : undefined;

        storage.showStandard = showStandard;
        storage.showCommunity = showCommunity;
        storage.showPersonal = showPersonal;
        
        storage.showLikedOnly = showLikedOnly;
        storage.showDislikedOnly = showDislikedOnly;
        storage.showFavouritesOnly = showFavouritesOnly;
        storage.showRecentsOnly = showRecentsOnly;
        storage.showBrOnly = showBrOnly;
        sessionStorage[filterKey] = JSON.stringify(storage);
        
    }

    function resetForm() {
        form_searchBox = '';
        form_minDuration = undefined;
        form_maxDuration = undefined;
        form_minXSS = undefined;
        form_maxXSS = undefined;
        form_selectedFocus = focus[0];
        form_selectedSpecificity = specificity[0];
        form_selectedPill = ReccTrainingPills[0];
        form_minDiamonds = undefined;
        form_maxDiamonds = undefined;
        form_showStandard = true;
        form_showCommunity = true;
        form_showPersonal = true;
        form_showLikedOnly = false;
        showDislikedOnly = false;
        form_showFavouritesOnly = false;
        form_showRecentsOnly = true;
        form_showBrOnly = defaultToBr;
    }

    function applyForm() {
        searchBox = form_searchBox
        minDuration = form_minDuration
        maxDuration = form_maxDuration
        minXSS = form_minXSS
        maxXSS = form_maxXSS
        minDiamonds = form_minDiamonds
        maxDiamonds = form_maxDiamonds
        selectedFocus = form_selectedFocus
        selectedSpecificity = form_selectedSpecificity
        selectedPill = form_selectedPill
        showStandard = form_showStandard
        showCommunity = form_showCommunity
        showPersonal = form_showPersonal
        showLikedOnly = form_showLikedOnly
        showDislikedOnly = form_showDislikedOnly
        showFavouritesOnly = form_showFavouritesOnly
        showRecentsOnly = form_showRecentsOnly
        showBrOnly = form_showBrOnly

        durationManuallyChanged = willManuallyChangeDuration;
        saveToSessionStorage();

        closeModal();
        setTimeout(onApply, 0);
    }

    if (doLoadFromSessionStorage) loadFromSessionStorage();
</script>

{#if !hideFilterButton}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <span class={'icon' + (hasFilter ? ' has-filter' : '')} on:click={showModal}>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5H8C9.378 12.5 10.5 11.378 10.5 10V8C10.5 6.622 9.378 5.5 8 5.5H6C4.622 5.5 3.5 6.622 3.5 8V10C3.5 11.378 4.622 12.5 6 12.5ZM4.5 8C4.5 7.173 5.173 6.5 6 6.5H8C8.827 6.5 9.5 7.173 9.5 8V10C9.5 10.827 8.827 11.5 8 11.5H6C5.173 11.5 4.5 10.827 4.5 10V8Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 24.5H24C25.378 24.5 26.5 23.378 26.5 22V20C26.5 18.622 25.378 17.5 24 17.5H22C20.622 17.5 19.5 18.622 19.5 20V22C19.5 23.378 20.622 24.5 22 24.5ZM20.5 20C20.5 19.173 21.173 18.5 22 18.5H24C24.827 18.5 25.5 19.173 25.5 20V22C25.5 22.827 24.827 23.5 24 23.5H22C21.173 23.5 20.5 22.827 20.5 22V20Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 18.5H16C17.378 18.5 18.5 17.378 18.5 16V14C18.5 12.622 17.378 11.5 16 11.5H14C12.622 11.5 11.5 12.622 11.5 14V16C11.5 17.378 12.622 18.5 14 18.5ZM12.5 14C12.5 13.173 13.173 12.5 14 12.5H16C16.827 12.5 17.5 13.173 17.5 14V16C17.5 16.827 16.827 17.5 16 17.5H14C13.173 17.5 12.5 16.827 12.5 16V14Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 6.5C6.724 6.5 6.5 6.276 6.5 6V4C6.5 3.724 6.724 3.5 7 3.5C7.276 3.5 7.5 3.724 7.5 4V6C7.5 6.276 7.276 6.5 7 6.5Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 26.5C6.724 26.5 6.5 26.276 6.5 26V12C6.5 11.724 6.724 11.5 7 11.5C7.276 11.5 7.5 11.724 7.5 12V26C7.5 26.276 7.276 26.5 7 26.5Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 26.5C14.724 26.5 14.5 26.276 14.5 26V18C14.5 17.724 14.724 17.5 15 17.5C15.276 17.5 15.5 17.724 15.5 18V26C15.5 26.276 15.276 26.5 15 26.5Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 12.5C14.724 12.5 14.5 12.276 14.5 12V4C14.5 3.724 14.724 3.5 15 3.5C15.276 3.5 15.5 3.724 15.5 4V12C15.5 12.276 15.276 12.5 15 12.5Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 18.5C22.724 18.5 22.5 18.276 22.5 18V4C22.5 3.724 22.724 3.5 23 3.5C23.276 3.5 23.5 3.724 23.5 4V18C23.5 18.276 23.276 18.5 23 18.5Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 26.5C22.724 26.5 22.5 26.276 22.5 26V24C22.5 23.724 22.724 23.5 23 23.5C23.276 23.5 23.5 23.724 23.5 24V26C23.5 26.276 23.276 26.5 23 26.5Z" fill="currentColor"/>
        </svg>
        <p>Filter</p>
    </span>
{/if}

<Modal bind:this={modalThis} showXButton={false} id="filterModal">
    <h4 slot="title" class="modal-title" id="myModalLabel">{title}</h4>

    <div class="modal-row">
        <p style="color: var(--color-xert-gray;">Search</p>
        <span class="searchbar">
            <input class="" type=text bind:value={form_searchBox} placeholder="Enter a search term"/>
            <button id="searchbtn">
                <i class="fa-solid fa-magnifying-glass"></i>
            </button>
        </span>
    </div>

    {#if form_selectedPill && showActivityFilters}
        <div class="modal-row">
            <p style="color: var(--color-xert-gray;">Type</p>
                <Select isClearable={false} bind:value={form_selectedPill} items={ReccTrainingPills} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
        </div>
    {/if}

    <div class="modal-row">
        <p style="color: var(--color-xert-gray;">Duration (minutes)</p>
        <div class="input-row">
            <input class="number-input" type=number min=0 max={maxDuration} on:input={onDurationInput} bind:value={form_minDuration} placeholder="Minimum Duration"/>
            <p>To</p>
            <input class="number-input" type=number min={minDuration} on:input={onDurationInput} bind:value={form_maxDuration} placeholder="Maximum Duration"/>
        </div>
    </div>

    <div class="modal-row">
        <p style="color: var(--color-xert-gray;">XSS</p>
        <div class="input-row">
            <input class="number-input" type=number min=0 max={maxXSS} bind:value={form_minXSS} placeholder="Minimum XSS"/>
            <p>To</p>
            <input class="number-input" type=number min={minXSS} bind:value={form_maxXSS} placeholder="Maximum XSS"/>
        </div>
    </div>
    <div class='row-double'>
        <div class="modal-row">
            <p style="color: var(--color-xert-gray;">Specificity</p>
            <Select isClearable={false} bind:value={form_selectedSpecificity} items={specificity} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
        </div>
        <div class="modal-row">
            <p style="color: var(--color-xert-gray;">Focus</p>
            <Select isClearable={false} bind:value={form_selectedFocus} items={focus} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
        </div>
    </div>

    <div class="modal-row">
        <p style="color: var(--color-xert-gray;">Difficulty</p>
        <div class="input-row">
            <span style="width: 200px; flex-grow: 1;">
                <Select isClearable={false} bind:value={form_minDiamonds} items={diamonds} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
            </span>
            <p>To</p>
            <span style="width: 200px; flex-grow: 1;">
                <Select isClearable={false} bind:value={form_maxDiamonds} items={diamonds} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'}/>
            </span>
        </div>
    </div>

    {#if showSource}
        <div class="modal-row">
            <p style="color: var(--color-xert-gray;">Workout/Session Source</p>
            <div class="input-row source-selector">
                <input type=checkbox bind:checked={form_showStandard} name="standard"/>
                <label for="standard">Standard</label>
                <input type=checkbox bind:checked={form_showCommunity} name="community"/>
                <label for="community">Community</label>
                <input type=checkbox bind:checked={form_showPersonal} name="personal"/>
                <label for="personal">Personal</label>
            </div>
        </div>
    {/if}
    {#if showLikedDisliked}
        <div class="modal-row">
            <div class="input-row like-dislike-selector">
                <input type=checkbox bind:checked={form_showLikedOnly}/>
                <label for="standard">Show Liked Only</label>
                <input type=checkbox bind:checked={form_showDislikedOnly}/>
                <label for="standard">Show Disliked Only</label>
            </div>
        </div>
    {/if}
    {#if showActivityFilters}
        <div class="modal-row">
            <p style="color: var(--color-xert-gray;">Activity Filters</p>
            <div class="input-row activity-filters-selector">
                {#if !forceFavOnly}
                    <input type=checkbox bind:checked={form_showFavouritesOnly}/>
                    <label for="standard">Favourites Only</label>
                {/if}
                <input type=checkbox bind:checked={form_showRecentsOnly}/>
                <label for="standard">{"Recents Only (past 3 months)"}</label>
                <input type=checkbox bind:checked={form_showBrOnly}/>
                <label for="standard">{"Show only breakthroughs"}</label>
            </div>
        </div>
    {/if}

    <svelte:fragment slot="footer">
        <button type="button" class="btn btn-default" on:click={resetForm} style="float:left">Reset</button>
        <button type="button" class="btn btn-default" on:click={applyForm}>Apply Filter</button>
    </svelte:fragment>
</Modal>


<style lang="scss">
    .row-double {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 34px;
        
        > .modal-row {
            width: 100%;
        }
    }

    .searchbar {
        display: flex;
        width: 100%;

        > input {
            flex-grow: 1;
            font-family: "Open Sans", sans-serif;
            font-size: 14px;
            height: 30px;
            padding: 2px 12px;
            border: 1px solid var(--color-xert-gray);
            border-top-left-radius: var(--borderRadius) !important;
            border-bottom-left-radius: var(--borderRadius) !important;
            border-right: none !important;
            outline: none;
            color: var(--color-xert-gray-text);
        }

        > button {
            height: 30px;
            width: 30px;
            border: 1px solid var(--color-xert-gray-text);
            border-top-right-radius: var(--borderRadius) !important;
            border-bottom-right-radius: var(--borderRadius) !important;
            border-left: none !important;
            background-color: white;

            > i {
                color: #ddd;
            }
        }

        > button:hover {
            > i {
                color: var(--color-xert-blue);
            }
        }
    }

    input.number-input {
        width: calc((100% - 37.91px) / 2);
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        height: 30px;
        padding: 2px 12px;
        border: 1px solid var(--color-xert-gray);
        border-radius: var(--borderRadius) !important;
        outline: none;
        color: var(--color-xert-gray-text);
    }

    .modal-row {
        --fontSize: 16px;
        --height: 30px;
        --padding: 0 12px !important;
        --itemColor: var(--color-xert-gray-text);
        --border: 1px solid var(--color-xert-gray);
        --borderFocusColor: var(--color-xert-gray);
        --borderHoverColor: var(--color-xert-blue);
        --borderRadius: 3px !important;
        --listBorder: 1px solid var(--color-xert-blue);

        --indicatorRight: 20px;
        --indicatorTop: 0;
        --indicatorHeight: 0;
        --indicatorWidth: 0;

        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 5px auto;

        .input-row {
            display: flex;
            gap: 10px;
            
            > p {
                margin: auto 0;
            }
        }

        > p {
            text-align: left;
            margin: 10px 0 !important;
        }
    }

    .source-selector, .like-dislike-selector, .activity-filters-selector {
        gap: 20px;

        > input {
            margin: 0 !important;
        }

        > label {
            margin: 0 10px 0 0 !important;
        }
    }

    .icon {
        display: flex;
        flex-direction: row;
        color: var(--color-xert-gray-text);
        margin: auto 0;

        &.has-filter {
            color: red !important;
        }

        > svg {
            cursor: pointer;
        }

        > p {
            margin: auto 3px !important;
            cursor: pointer;
        }
    }

    .icon:hover {
        color: var(--color-xert-blue);
        cursor: default;
    }

</style>
